module.exports = __webpack_public_path__ + "img/extra-step-2.47e47273.png";